import React from 'react';
import styled from 'styled-components';
import LottieLogo from './LottieLogo';
import NavBar from './NavBar';
import { useAuth0 } from '../helpers/react-auth0-spa.js';

const SDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  width: 90vw;

  @media (orientation: landscape) {
    height: 70vh;
  }
`;

const Home = (props: any) => {
  const { isAuthenticated } = useAuth0();
  const { history } = props;

  return (
    <>
      {isAuthenticated && history.push('/admin')}
      <NavBar />
      <SDiv className='Home'>
        <LottieLogo height={'40vh'} width={'40vh'} />
        <p style={{ width: '60%' }}>How are you today?</p>
      </SDiv>
    </>
  );
};

export default Home;
